import React from "react";
import { Star } from "lucide-react";

export const GOOGLE_REVIEWS_URL = "https://g.page/r/CfoWwSULqc7CEBM/review";

// Stars + link to Google so visitors see current reviews there (no numbers shown on site).
const ReviewStars = ({ className = "", starClass = "w-4 h-4" }) => (
  <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="review-stars" className={`group flex items-center gap-2 w-fit ${className}`}>
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className={`${starClass} fill-[#fbbf24] text-[#fbbf24]`} />
      ))}
    </div>
    <span className="text-sm text-slate-500 underline underline-offset-2 group-hover:text-[#3b9dff] transition-colors" data-testid="review-count">
      Google reviews
    </span>
  </a>
);

export default ReviewStars;
